import React from "react";
import "./infoModal.scss";
import Modal from "../../atoms/modal-pay/modal-pay";
import Button from "../../atoms/button/button";

interface infoModalInterface {
  isOpen: boolean;
  setIsOpen: any;
  continuarCompra: any;
  data:any;
}

const infoModal = (props: infoModalInterface) => {

  const { isOpen, setIsOpen, data } = props;

  return (
    <Modal open={isOpen} onClose={() => {}} className={"m-modal-info"}>
      <div className={`m-modal-info__container`}>
        <div className="m-modal-info__container__header">
          <div className="m-modal-info__container__header__close">
            <button className="icon-close" onClick={() => setIsOpen(false)} />
          </div>
        </div>
        <div className="m-modal-info__container__body">
          <div className="m-modal-info__container__body__group">
            <h3>{data.tituloBanner}</h3>
          </div>
          <div className="m-modal-info__container__body__steps">
            <div className="m-modal-info__container__body__steps__step-1">
              <div className="m-modal-info__container__body__steps__step-1__txt">
                  {data.descripcion.content.map((msg:any, index) => {
                    return <p key={index}>{msg.content[0].value}</p>
                  })}
              </div>
            </div>
            <div className="m-modal-info__container__body__steps__btn">
              <Button
                text={data.tituloBoton}
                classname={"a-button secondary s-small"}
                type={"button"}
                isDisabled={false}
                strictCss={false}
                gtmMark={"gtmInternaGruposApoyoAgendaCita"}
                onClickAction={() => {
                    props.continuarCompra();
                  }
                }
              /> 
              </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default infoModal;
